// SearchContextWrapper.js
import React from 'react';
import { useSearch } from '../utils/SearchContext';
import Navbar from '../../src/components/ui/mainScreen/navbar'; // подставьте правильный путь

function SearchContextWrapper() {
    const searchContextValue = useSearch();
    return <Navbar searchContextValue={searchContextValue} />;
}

export default SearchContextWrapper;